import { render, staticRenderFns } from "./Paddles.vue?vue&type=template&id=7a8fa8c6&"
import script from "./Paddles.vue?vue&type=script&lang=js&"
export * from "./Paddles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports